import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';

interface ResponsiveContainerProps {
  children: React.ReactNode;
  maxWidth?: string | number;
  disableGutters?: boolean;
  showBoundary?: boolean;
  sx?: any;
}

const SIDEBAR_WIDTH = 90; // px
const SIDEBAR_GAP = 10;   // px gap between sidebar and content area

const ResponsiveContainer: React.FC<ResponsiveContainerProps> = ({
  children,
  maxWidth = 1400,
  disableGutters = false,
  showBoundary = false,
  sx = {}
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <Box
        sx={{
          width: '100%',
          minWidth: { sm: 400, xs: 288 },
          px: disableGutters ? 0 : { xs: 2, sm: 3 },
          ...(showBoundary && {
            borderRadius: 0,
          }),
          ...sx
        }}
      >
        {children}
      </Box>
    );
  }

  // Desktop: full-width wrapper that reserves sidebar space on the left,
  // then centers the max-width content box in the remaining area.
  return (
    <Box
      sx={{
        width: '100%',
        pl: `${SIDEBAR_WIDTH + SIDEBAR_GAP}px`,
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          maxWidth: { md: 1200, lg: 1400 },
          minWidth: 400,
          mx: 'auto',
          px: disableGutters ? 0 : { md: 4, lg: 5 },
          ...(showBoundary && {
            borderRadius: 2,
            bgcolor: theme.palette.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.02)'
              : 'rgba(0, 0, 0, 0.02)',
            my: 2,
          }),
          ...sx
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default ResponsiveContainer;
